module.exports = __webpack_public_path__ + "img/matchamacha.849f19bd.png";